import { connect } from 'react-redux';
import { AppState } from '../../../redux/reducers';
import { Sede, Sector, UpdateSector } from '../../../models/Entities/Turnero';
import { ErrorType } from '../../../models/HttpError';
import * as SedesStore from '../../../redux/middleware/Turnero/Turnero.Sedes.Middleware';
import * as SectoresStore from '../../../redux/middleware/Turnero/Turnero.Sectores.Middleware';

// Own props
export interface OwnProps {
  onSectorSelected?: (sectorId: number | null) => void;
}

// State props
interface StateProps {
  sedes: Sede[];
  sectores: Sector[];
  isLoading: boolean;
  isLoadedSuccessfully: boolean;
  isUpdatingSector: boolean;
  successUpdatingSector: boolean | undefined;
  failOnUpdatingSector: boolean;
  error: ErrorType | undefined;
}

// Dispatch props
interface DispatchProps {
  GetSedes: () => void;
  GetSectores: () => void;
  UpdateSector: (id: number, payload: UpdateSector) => void;
}

export type Props = OwnProps & StateProps & DispatchProps;

export const mapStateToProps = (state: AppState): StateProps => {
  const sectoresState = state.Turnero?.Sectores;
  return {
    sedes: state.Turnero?.Sedes?.list || [],
    sectores: sectoresState?.list || [],
    isLoading: Boolean(state.Turnero?.Sedes?.isLoadingAll || sectoresState?.isLoadingAll),
    isLoadedSuccessfully: Boolean(state.Turnero?.Sedes?.successLoadingAll && sectoresState?.successLoadingAll),
    isUpdatingSector: sectoresState?.isUpdatingOne || false,
    successUpdatingSector: sectoresState?.successUpdatingOne,
    failOnUpdatingSector: sectoresState?.failOnUpdatingOne || false,
    error: sectoresState?.error,
  };
};

export const mapDispatchToProps = (dispatch: any): DispatchProps => ({
  GetSedes: () => dispatch(SedesStore.actionCreators.GetSedes()),
  GetSectores: () => dispatch(SectoresStore.actionCreators.GetSectores()),
  UpdateSector: (id: number, payload: UpdateSector) => dispatch(SectoresStore.actionCreators.UpdateSector(id, payload))
});

export const connector = connect(mapStateToProps, mapDispatchToProps);
